import { IPeriodValue } from "@/consts/interfaces";

const PERIODS: Array<IPeriodValue> = [
  {name: "週間", value: 1},
  {name: "月間", value: 2},
  {name: "年間", value: 3},
]

const PERIODS_TYPE_LABEL_MAP: { [id: number] : string } = {
    1: "（今週）",
    2: "（今月）",
    3: "（今年）",
}

export {PERIODS, PERIODS_TYPE_LABEL_MAP}
